import React from 'react';
import { Control, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { DiscountTypes } from 'api';
import { dataInitialSelectsOptions } from '../../../fields';
import DiscountValueBlock from './DiscountValueBlock';
import ProductsBlock from './ProductsBlock';
import EligibilityBlock from './EligibilityBlock';
import MinRequirementsBlock from './MinRequirementsBlock';

interface Props {
  control: Control<DiscountTypes.ItemCreateParams> | undefined;
  watch: UseFormWatch<DiscountTypes.ItemCreateParams>;
  setValue: UseFormSetValue<DiscountTypes.ItemCreateParams>;
  initialSelectsOptions:
    | ReturnType<typeof dataInitialSelectsOptions>
    | undefined;
}

const DefaultDiscount: React.FC<Props> = (props: Props): JSX.Element => {
  const { control, watch, setValue, initialSelectsOptions } = props;

  return (
    <>
      <DiscountValueBlock control={control} watch={watch} setValue={setValue} />
      <ProductsBlock
        control={control}
        watch={watch}
        setValue={setValue}
        initialSelectsOptions={initialSelectsOptions}
      />
      <MinRequirementsBlock
        control={control}
        watch={watch}
        setValue={setValue}
      />
      <EligibilityBlock
        control={control}
        watch={watch}
        setValue={setValue}
        initialSelectsOptions={initialSelectsOptions}
      />
    </>
  );
};

export default DefaultDiscount;
